export function ProgressBar({ percent }: { percent: number }) {
  return (
    <div className="h-2 w-full overflow-hidden rounded-full bg-[var(--status-active)]/20">
      <div
        className="h-full rounded-full bg-[var(--status-active)]"
        style={{ width: `${percent}%` }}
      />
    </div>
  );
}
